import { useQueryWithUserId } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

/**
 * React query state key for fetch bids stepper value api it can invalidate
 * the state of bid stepper value
 */
const FETCH_BIDS_STEPPER_VALUE_QUERY_KEY = 'fetch-bids-stepper-value-query-key';

/**
 * React Query hook for bid STEPPER VALUE it will call
 * `fetchBidStepperValue` and give error loading success state with response
 */
export const useBidStepperValQuery = (assetId: string) => {
  const { data, isError, error, isFetching, isPending, refetch, isSuccess } =
    useQueryWithUserId({
      queryKey: [FETCH_BIDS_STEPPER_VALUE_QUERY_KEY, assetId],
      queryFn: () => BIDS_API.fetchBidStepperValue(assetId),
      retry: false,
      enabled: !!assetId,
    });

  return {
    data,
    isError,
    error,
    isFetching,
    isPending,
    isSuccess,
    refetch,
  };
};
